module.exports = __webpack_public_path__ + "static/media/devdrill.8d89456f.png";